export default __webpack_public_path__ + "static/media/storytelling.f818a247.pdf";